import { CacheableDataObject } from './CacheableDataObject.jsx';
import { Stage } from "./Stage.jsx";
import NumberHelper from "../functions/NumberHelper.js";

class Character extends CacheableDataObject {
	beforeConstruct() {
		this.characterDataIsPopulatedBoolean = false;
		this.characterDataIsPopulated = new Promise((resolve) => {
			this.characterDataIsPopulatedResolve = resolve;
		});
	}

	generateElement() {
		let characterImage = $('<div>').addClass('character');
		if(this.characterDataIsPopulatedBoolean) {
			this.populateCharacterData(characterImage);
		}
		else {
			this.characterDataIsPopulated.then(() => {
				this.populateCharacterData(characterImage);
			});
		}
		return characterImage;
	}

	populateCharacterData(characterImage) {
		characterImage.addClass('character_for_game_' + this.game_slug)
			.addClass('character_name_' + this.slug_name)
			.addClass('character_id_' + this.id)
			.data('id', this.id)
			.data('name', this.name)
			.attr('title', this.name)
			.css('background-image', 'url(' + this.image_url + ')');

		let nameContainer = $('<span>').addClass('name').text(this.name);
		nameContainer.appendTo(characterImage);
		if(this.percent) {
			var percentage = $('<span>').addClass('badge percentage').text(this.percent);
			percentage.appendTo(characterImage);
		}
	}

	afterUpdate() {
		if(this.name) {
			this.characterDataIsPopulatedResolve();
			this.characterDataIsPopulatedBoolean = true;
		}
	}

	getUsageRatio(decimalPlaces = 0) {
		return NumberHelper.getRatio(this.times_used, this.total_games, decimalPlaces);
	}

	getWinRatio() {
		return NumberHelper.getRatio(this.wins, this.losses);
	}
}

Character.prototype.dataLocationParsers = {
	id: (character, data) => {
		character.id = Number.parseInt(data.id, 10);
	},
	wins: (character, data) => {
		character.wins = isNumeric(data.wins) ? Number.parseInt(data.wins) : null;
	},
	losses: (character, data) => {
		character.losses = isNumeric(data.losses) ? Number.parseInt(data.losses) : null;
	},
	stage_pick: (character, data) => { //Used for statistic pages
		character.stage_pick = data.stage_pick ? Stage.create(data.stage_pick) : null;
	},
	vs_characters: (character, data) => {
		const vsCharacterList = [];
		for(let vs_character of data.vs_characters) {
			const vsCharacter = Character.create(vs_character);
			vsCharacterList.push(vsCharacter);
		}
		console.log('vs list', vsCharacterList);
		vsCharacterList.sort((a, b) => {
			if(a.getWinRatio() === b.getWinRatio()) {
				if(a.wins === b.wins) {
					return 0;
				}
				return a.wins > b.wins ? 1 : -1;
			}
			console.log('compare', a.getWinRatio(), '>', b.getWinRatio(), a.getWinRatio() > b.getWinRatio());
			return a.getWinRatio() > b.getWinRatio() ? -1 : 1;
		});
		character.vs_characters = vsCharacterList;
	},
	by_stage: (character, data) => {
		const byStage = [];
		_.each(data.by_stage, (stageStats) => {
			stageStats = CharacterStageStats.create(stageStats);
			byStage.push(stageStats);
		});
		byStage.sort((a, b) => {
			return a.getWinRatio() > b.getWinRatio() ? -1 : 1;
		});
		character.by_stage = byStage;
	}
};

class CharacterStageStats extends CacheableDataObject {
	getWinRatio() {
		return NumberHelper.getRatio(this.wins, this.losses);
	}
}

CharacterStageStats.prototype.dataLocationParsers = {
	stage: (stats, data) => {
		stats.stage = Stage.create(data.stage);
	},
};

export { Character };